<template>
  <div>
    <viewTable
      ref="viewTable"
      :limits="limits"
      :columns-property="columnsProperty"
      :filter="filter"
      module="basic"
      url="fm/production-mangeline"
      @addOrEdit="addEditHandle"
      @delete="deleteHandle"
      @reset="resetHandle"
    >
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="产线编码">
            <el-input v-model.trim="filter.lineCode" placeholder="请输入产线编码" clearable />
          </el-form-item>
          <el-form-item label="产线全称">
            <el-input v-model.trim="filter.lineName" placeholder="请输入产线全称" clearable />
          </el-form-item>
          <el-form-item label="产线简称">
            <el-input v-model.trim="filter.lineShortName" placeholder="请输入产线简称" clearable />
          </el-form-item>
          <el-form-item label="产线类型">
            <el-select v-model="filter.lineType" placeholder="请选择产线类型" clearable>
              <el-option v-for="item in lineTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="产线状态">
            <el-select v-model="filter.lineStatus" placeholder="请选择产线状态" clearable>
              <el-option v-for="item in lineStatusOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
        </el-form>
      </template>
    </viewTable>
    <ProductionLineEdit ref="productionLineEdit" @save-success="loadData" />
  </div>
</template>

<script>
import viewTable from "@/components/ViewTable.vue";
import ProductionLineEdit from "./ProductionLineEdit";

export default {
  components: { viewTable, ProductionLineEdit },
  data() {
    return {
      limits: {
        addAuth: this.$auth(152),
        editAuth: this.$auth(153),
        delAuth: this.$auth(154),
      },
      lineTypeOptions: [
        { label: "组装", value: 1 },
        { label: "测试", value: 2 },
        { label: "发料", value: 3 },
        { label: "包装", value: 4 },
        { label: "发货前处理", value: 5 },
        { label: "老化", value: 6 },
      ],
      lineStatusOptions: [
        { label: "停用封存", value: 0 },
        { label: "正常运行", value: 1 },
        { label: "检修停机", value: 2 },
        { label: "改造调试中", value: 3 },
      ],
      filter: {
        lineCode: "",
        lineName: "",
        lineShortName: "",
        lineType: null,
        lineStatus: null,
      },
      columnsProperty: [
        { tooltip: true, key: "lineCode", width: 130, align: "center" },
        { tooltip: true, key: "lineName", minWidth: 180 },
        { tooltip: true, key: "lineShortName", width: 120 },
        { tooltip: true, key: "lineTypeName", width: 100, align: "center" },
        { tooltip: true, key: "lineStatusName", width: 100, align: "center" },
        { key: "action", align: "center", width: 100, slot: "action" },
      ],
    };
  },
  methods: {
    loadData(pageNum) {
      this.$refs.viewTable.loadData(pageNum);
    },
    addEditHandle(row) {
      this.$refs.productionLineEdit.open(row);
    },
    deleteHandle(row) {
      this.$http.delete("basic", "fm/production-mangeline", row.id).then((resp) => {
        if (resp.success) {
          this.$message.success("删除成功");
          this.loadData();
        }
      });
    },
    resetHandle(filter) {
      this.filter = Object.assign(this.filter, filter);
    },
  },
};
</script>
